import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiActivity } from 'react-icons/fi';

const Navbar = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded bg-brand-600 flex items-center justify-center text-white">
            <SafeIcon icon={FiActivity} className="w-5 h-5" />
          </div>
          <span className="font-bold text-xl tracking-tight text-slate-900 italic">Scorewidget</span>
        </Link>

        <nav className="hidden md:flex gap-8 text-sm font-medium text-slate-500">
          {isHome ? (
            <>
              <a href="#leagues" className="hover:text-brand-600 transition-colors">Leagues</a>
              <a href="#features" className="hover:text-brand-600 transition-colors">How it works</a>
              <a href="#faq" className="hover:text-brand-600 transition-colors">FAQ</a>
            </>
          ) : (
            <>
              <Link to="/#leagues" className="hover:text-brand-600 transition-colors">Leagues</Link>
              <Link to="/#features" className="hover:text-brand-600 transition-colors">How it works</Link>
              <Link to="/#faq" className="hover:text-brand-600 transition-colors">FAQ</Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            to="/builder"
            className="px-5 py-2 text-sm font-bold text-white bg-brand-600 hover:bg-brand-700 rounded-full transition-all shadow-sm"
          >
            Build Now
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
